// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3BqcQ","title":"ClientReferral_title__1VIrK","itemText":"ClientReferral_itemText__27EdE"};